import { Injectable } from '@angular/core';
import { AppConfig } from './config.contract';
import { environment } from '../../../environments/environment';
import { CONST_CONFIG, EXTERNAL_CONFIG } from './constants/const.config';

@Injectable()
export class ConfigService {
  constructor() { }

  get appConfig(): AppConfig {
    return EXTERNAL_CONFIG.appConfig;
  }

  get env() {
    return environment;
  }

  get const() {
    return CONST_CONFIG;
  }

  get isConfigLoaded() {
    return (EXTERNAL_CONFIG.isLoaded === true );
  }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/config/config.service.ts